import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
//import { getDatabase } from 'firebase/database';
//import { getStorage } from 'firebase/storage';

// Validate that we can access environment variables
if (typeof import.meta.env === 'undefined') {
  throw new Error('Environment variables are not accessible. Make sure you are using Vite and your .env file is properly configured.');
}

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

if (!firebaseConfig.apiKey) {
  console.error('Firebase configuration error: API Key is missing');
  throw new Error('Firebase API Key is missing. Make sure your .env file is set up correctly and you have restarted your development server.');
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
// Initialize Realtime Database and get a reference to the service
//export const db = getDatabase(app);

// Initialize Storage and get a reference to the service
//export const storage = getStorage(app);

export default app; 